import { FC } from 'react';
import CloudFrame from '../CloudFrame/CloudFrame';
import CloudFallback from '../CloudFrame/CloudFallback';

const CloudNHI: FC = () => (
    <div className="h-screen w-[calc(100vw-64px)] ml-16 bg-sf-white">
        <CloudFrame
            srcRoute={`/silverfort/v1/non-human-identities`}
            fallback={<CloudFallback />}
            className="w-full h-full overflow-hidden"
        />
    </div>
);

export default CloudNHI;
